// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37TsB","location":"Header_location__1Py_x"};